import React from 'react';
import DataTableCard from 'components/DataTableCard';
import strftime from 'strftime';



type WeekExerciseMeanProps = {
    partner : string | string[]
    start? : Date
    end? : Date
    periodSubtitle? : string

}

function WeekExerciseMean(props:WeekExerciseMeanProps) {

    const startDate = props.start ? strftime("%Y-%m-%d", props.start) : ""
    const endDate = props.end ? strftime("%Y-%m-%d", props.end) : ""


    return (
        <DataTableCard url="week-exercise-mean/" 
            partner={props.partner} 
            aux_url_params={ {start:startDate, end:endDate, periodSubtitle:props.periodSubtitle} }
            title="Exercises per User per Week" 
            subtitle="average number of exersises per user at user's X week" 
        />
    )
}

export default WeekExerciseMean;
